import { actionSetLayerFeatures } from '@tmapy/mapcore';
import { actionPrepareSaveFeatures } from './saveEditedFeature';
import { LAYER_IDS } from '@tmapy/config';
export const actionDeleteAndSaveFeature = (payload) => async (dispatch) => {
    const feature = payload.features
        .filter((feature) => feature.layerId === LAYER_IDS.EDIT_TOOLS_HIGHLIGHT)
        .map((feature) => feature.feature)?.[0];
    if (!feature)
        return;
    const featureProperties = feature.getProperties();
    const featureId = (feature.getId() || feature.get('id'));
    dispatch(actionSetLayerFeatures(LAYER_IDS.EDIT_TOOLS_HIGHLIGHT, []));
    const act = actionPrepareSaveFeatures([
        {
            layerId: featureProperties._originLayerId,
            featureId,
            feature: null,
        },
    ]);
    dispatch(act);
    await act.meta.responsePromise;
};
//# sourceMappingURL=actionDeleteAndSaveFeature.js.map